export const packageIds = {
  subOrgs: 7,
  subOrgsVideo: 135,
};
